import React from "react";
import BottomAppBar from "../components/BottomBar";
import Navigation from "../components/Navigation";
import { useTranslation } from "react-i18next";
const privacy_policy =
  "https://shiningstarsfostering.com/privacy-policy-shining-stars-fostering/";

const PrivcayPolicy = () => {
  const { t } = useTranslation();

  return (
    <>
      <Navigation title={t("PRIVACY_POLICY")} appBarColor="orange" />
      <div className="fixed-layout-main ">
        <iframe
          className="h-full w-full"
          src={privacy_policy}
          title="myFrame"
        />
      </div>
      <BottomAppBar />
    </>
  );
};

export default PrivcayPolicy;
